// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: LHZTBNzdnP

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: 5gQXQ5PIHOg/component
import EditTitleButton from "../../EditTitleButton"; // plasmic-import: zdbHibLQVF/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicHubListItem.module.css"; // plasmic-import: LHZTBNzdnP/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: rQjkwIrrF-2/icon
import IconsCloseIcon from "./icons/PlasmicIcon__IconsClose"; // plasmic-import: -dI1oop3LS/icon

createPlasmicElementProxy;

export type PlasmicHubListItem__VariantMembers = {
  isEditing: "isEditing";
  isHoveredAsTitle: "isHoveredAsTitle";
  isTitle: "isTitle";
};
export type PlasmicHubListItem__VariantsArgs = {
  isEditing?: SingleBooleanChoiceArg<"isEditing">;
  isHoveredAsTitle?: SingleBooleanChoiceArg<"isHoveredAsTitle">;
  isTitle?: SingleBooleanChoiceArg<"isTitle">;
};
type VariantPropType = keyof PlasmicHubListItem__VariantsArgs;
export const PlasmicHubListItem__VariantProps = new Array<VariantPropType>(
  "isEditing",
  "isHoveredAsTitle",
  "isTitle"
);

export type PlasmicHubListItem__ArgsType = {
  hubTitle?: React.ReactNode;
};
type ArgPropType = keyof PlasmicHubListItem__ArgsType;
export const PlasmicHubListItem__ArgProps = new Array<ArgPropType>("hubTitle");

export type PlasmicHubListItem__OverridesType = {
  hubTitleContainer?: p.Flex<"button">;
  inputComponent?: p.Flex<typeof TextInput>;
  titleContainer?: p.Flex<"div">;
  editTitleButton?: p.Flex<typeof EditTitleButton>;
};

export interface DefaultHubListItemProps {
  hubTitle?: React.ReactNode;
  isEditing?: SingleBooleanChoiceArg<"isEditing">;
  isHoveredAsTitle?: SingleBooleanChoiceArg<"isHoveredAsTitle">;
  isTitle?: SingleBooleanChoiceArg<"isTitle">;
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicHubListItem__RenderFunc(props: {
  variants: PlasmicHubListItem__VariantsArgs;
  args: PlasmicHubListItem__ArgsType;
  overrides: PlasmicHubListItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "inputComponent.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "" as const
      },
      {
        path: "isEditing",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isEditing
      },
      {
        path: "isHoveredAsTitle",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.isHoveredAsTitle
      },
      {
        path: "isTitle",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isTitle
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isHubTitleContainerHover, triggerHubTitleContainerHoverProps] =
    useTrigger("useHover", {});
  const triggers = {
    hover_hubTitleContainer: isHubTitleContainerHover
  };

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <p.Stack
      as={"button"}
      data-plasmic-name={"hubTitleContainer"}
      data-plasmic-override={overrides.hubTitleContainer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.hubTitleContainer,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.hubTitleContainerisEditing]: hasVariant(
            $state,
            "isEditing",
            "isEditing"
          ),
          [sty.hubTitleContainerisHoveredAsTitle]: hasVariant(
            $state,
            "isHoveredAsTitle",
            "isHoveredAsTitle"
          ),
          [sty.hubTitleContainerisTitle]: hasVariant(
            $state,
            "isTitle",
            "isTitle"
          )
        }
      )}
      ref={ref => {
        $refs["hubTitleContainer"] = ref;
      }}
      data-plasmic-trigger-props={[triggerHubTitleContainerHoverProps]}
    >
      {(hasVariant($state, "isEditing", "isEditing") ? true : true) ? (
        <TextInput
          data-plasmic-name={"inputComponent"}
          data-plasmic-override={overrides.inputComponent}
          className={classNames("__wab_instance", sty.inputComponent, {
            [sty.inputComponentisEditing]: hasVariant(
              $state,
              "isEditing",
              "isEditing"
            ),
            [sty.inputComponentisHoveredAsTitle]: hasVariant(
              $state,
              "isHoveredAsTitle",
              "isHoveredAsTitle"
            )
          })}
          context={"_default" as const}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["inputComponent", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          textAlignment={"center" as const}
          value={
            p.generateStateValueProp($state, ["inputComponent", "value"]) ?? ""
          }
        />
      ) : null}
      {true ? (
        <div
          data-plasmic-name={"titleContainer"}
          data-plasmic-override={overrides.titleContainer}
          className={classNames(projectcss.all, sty.titleContainer, {
            [sty.titleContainerisEditing]: hasVariant(
              $state,
              "isEditing",
              "isEditing"
            ),
            [sty.titleContainerisHoveredAsTitle]: hasVariant(
              $state,
              "isHoveredAsTitle",
              "isHoveredAsTitle"
            )
          })}
        >
          {(hasVariant($state, "isEditing", "isEditing") ? false : true)
            ? p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__a210Z
                    )}
                  >
                    {"Science News"}
                  </div>
                ),
                value: args.hubTitle,
                className: classNames(sty.slotTargetHubTitle, {
                  [sty.slotTargetHubTitleisEditing]: hasVariant(
                    $state,
                    "isEditing",
                    "isEditing"
                  ),
                  [sty.slotTargetHubTitleisHoveredAsTitle]: hasVariant(
                    $state,
                    "isHoveredAsTitle",
                    "isHoveredAsTitle"
                  ),
                  [sty.slotTargetHubTitleisTitle]: hasVariant(
                    $state,
                    "isTitle",
                    "isTitle"
                  )
                })
              })
            : null}
        </div>
      ) : null}
      {(
        hasVariant($state, "isHoveredAsTitle", "isHoveredAsTitle") ? true : true
      ) ? (
        <EditTitleButton
          data-plasmic-name={"editTitleButton"}
          data-plasmic-override={overrides.editTitleButton}
          className={classNames("__wab_instance", sty.editTitleButton, {
            [sty.editTitleButtonisHoveredAsTitle]: hasVariant(
              $state,
              "isHoveredAsTitle",
              "isHoveredAsTitle"
            ),
            [sty.editTitleButtonisTitle]: hasVariant(
              $state,
              "isTitle",
              "isTitle"
            )
          })}
          isTitleHovered={
            hasVariant($state, "isTitle", "isTitle") &&
            triggers.hover_hubTitleContainer
              ? true
              : hasVariant($state, "isHoveredAsTitle", "isHoveredAsTitle")
              ? true
              : undefined
          }
        />
      ) : null}
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  hubTitleContainer: [
    "hubTitleContainer",
    "inputComponent",
    "titleContainer",
    "editTitleButton"
  ],
  inputComponent: ["inputComponent"],
  titleContainer: ["titleContainer"],
  editTitleButton: ["editTitleButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  hubTitleContainer: "button";
  inputComponent: typeof TextInput;
  titleContainer: "div";
  editTitleButton: typeof EditTitleButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHubListItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHubListItem__VariantsArgs;
    args?: PlasmicHubListItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHubListItem__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHubListItem__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHubListItem__ArgProps,
          internalVariantPropNames: PlasmicHubListItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHubListItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "hubTitleContainer") {
    func.displayName = "PlasmicHubListItem";
  } else {
    func.displayName = `PlasmicHubListItem.${nodeName}`;
  }
  return func;
}

export const PlasmicHubListItem = Object.assign(
  // Top-level PlasmicHubListItem renders the root element
  makeNodeComponent("hubTitleContainer"),
  {
    // Helper components rendering sub-elements
    inputComponent: makeNodeComponent("inputComponent"),
    titleContainer: makeNodeComponent("titleContainer"),
    editTitleButton: makeNodeComponent("editTitleButton"),

    // Metadata about props expected for PlasmicHubListItem
    internalVariantProps: PlasmicHubListItem__VariantProps,
    internalArgProps: PlasmicHubListItem__ArgProps
  }
);

export default PlasmicHubListItem;
/* prettier-ignore-end */
